import type { ApDocumentType } from "@/accounts-payable/types";
import { invoiceKey, receiptKey } from "./keys";

export const documentKey = (
  documentType: ApDocumentType,
  businessId?: string | null,
  documentId?: string | null,
) =>
  documentType === "receipt"
    ? receiptKey(businessId, documentId)
    : invoiceKey(businessId, documentId);
